import * as React from 'react';

import { VideoPlayer } from '../../VideoPlayer';
import { IMediaItemDesktopSchema } from '../FullscreenGallery';
import { getVideoId } from '../utils/getVideoId';

export const VideoSlide = ({ media, index }: { media: IMediaItemDesktopSchema; index: number }) => {
  const id = getVideoId(media.videoUrl as string) || '';

  return <VideoPlayer videoId={id} key={index} />;
};
